/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
    VisualReferenceToJSONTyped,
} from './VisualReference';
import type { MedicareConditionsServices } from './MedicareConditionsServices';
import {
    MedicareConditionsServicesFromJSON,
    MedicareConditionsServicesFromJSONTyped,
    MedicareConditionsServicesToJSON,
    MedicareConditionsServicesToJSONTyped,
} from './MedicareConditionsServices';
import type { NtaConditionEvidence } from './NtaConditionEvidence';
import {
    NtaConditionEvidenceFromJSON,
    NtaConditionEvidenceFromJSONTyped,
    NtaConditionEvidenceToJSON,
    NtaConditionEvidenceToJSONTyped,
} from './NtaConditionEvidence';

/**
 * 
 * @export
 * @interface AssessmentFormConditionsServices
 */
export interface AssessmentFormConditionsServices {
    /**
     * 
     */
    conditions_services: Array<MedicareConditionsServices>;
    /**
     * 
     */
    readonly predicted_conditions_services?: Array<MedicareConditionsServices>;
    /**
     * 
     */
    readonly predicted_conditions_services_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_conditions_services_visual_references?: Array<VisualReference>;
    /**
     * Trinary evidence ratings for NTA conditions. When present, this takes precedence over conditions_services.
     */
    conditions_services_evidence?: Array<NtaConditionEvidence>;
    /**
     * AI-predicted trinary evidence ratings for NTA conditions.
     */
    readonly predicted_conditions_services_evidence?: Array<NtaConditionEvidence>;
}

/**
 * Check if a given object implements the AssessmentFormConditionsServices interface.
 */
export function instanceOfAssessmentFormConditionsServices(value: object): value is AssessmentFormConditionsServices {
    if (!('conditions_services' in value) || value['conditions_services'] === undefined) return false;
    return true;
}

export function AssessmentFormConditionsServicesFromJSON(json: any): AssessmentFormConditionsServices {
    return AssessmentFormConditionsServicesFromJSONTyped(json, false);
}

export function AssessmentFormConditionsServicesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentFormConditionsServices {
    if (json == null) {
        return json;
    }
    return {
        
        'conditions_services': ((json['conditions_services'] as Array<any>).map(MedicareConditionsServicesFromJSON)),
        'predicted_conditions_services': json['predicted_conditions_services'] == null ? undefined : ((json['predicted_conditions_services'] as Array<any>).map(MedicareConditionsServicesFromJSON)),
        'predicted_conditions_services_reasoning': json['predicted_conditions_services_reasoning'] === undefined ? undefined : json['predicted_conditions_services_reasoning'] === null ? null : json['predicted_conditions_services_reasoning'],
        'predicted_conditions_services_visual_references': json['predicted_conditions_services_visual_references'] == null ? undefined : ((json['predicted_conditions_services_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'conditions_services_evidence': json['conditions_services_evidence'] == null ? undefined : ((json['conditions_services_evidence'] as Array<any>).map(NtaConditionEvidenceFromJSON)),
        'predicted_conditions_services_evidence': json['predicted_conditions_services_evidence'] == null ? undefined : ((json['predicted_conditions_services_evidence'] as Array<any>).map(NtaConditionEvidenceFromJSON)),
    };
}

export function AssessmentFormConditionsServicesToJSON(json: any): AssessmentFormConditionsServices {
    return AssessmentFormConditionsServicesToJSONTyped(json, false);
}

export function AssessmentFormConditionsServicesToJSONTyped(value?: Omit<AssessmentFormConditionsServices, 'predicted_conditions_services'|'predicted_conditions_services_reasoning'|'predicted_conditions_services_visual_references'|'predicted_conditions_services_evidence'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conditions_services': ((value['conditions_services'] as Array<any>).map(MedicareConditionsServicesToJSON)),
        'conditions_services_evidence': value['conditions_services_evidence'] == null ? undefined : ((value['conditions_services_evidence'] as Array<any>).map(NtaConditionEvidenceToJSON)),
    };
}

